import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogProps, DialogTitle, Paper, PaperProps } from '@mui/material';
import React, { Dispatch, SetStateAction } from 'react';
import Draggable from 'react-draggable';

const PaperComponent: React.FC<PaperProps> = (props: PaperProps) => {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}

type ConfirmationDialogProps = {
    Title: string;
    Prompt: string;
    OKButton?: string;
    CancelButton?: string;
    setOpened: Dispatch<SetStateAction<boolean>>;
    OnClose: (confirmed:boolean) =>any;
}  & DialogProps

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = (dialogProps: ConfirmationDialogProps) => {
    const { sx } = dialogProps; 

    const handleClose : any = (confirmed:boolean) => {
        dialogProps.OnClose(confirmed);
    };

    React.useEffect(() => {
        // THIS EMPTY LINE IS REQUIRED TO SHOW 
        // COMPONENT FROM PARENT COMPONENT

    }, [dialogProps.open]);

    return (
        <div>
            <Dialog sx={sx}
                open={dialogProps.open}
                onClose={e => { } }
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title" >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    {dialogProps.Title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {dialogProps.Prompt}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={() => handleClose(false) } color="secondary">
                        {dialogProps.CancelButton ?? "Cancel"}
                    </Button>
                    <Button onClick={() => handleClose(true)} color="secondary">
                        {dialogProps.OKButton ?? "OK"}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
